/* @flow */
import Config from 'Config';

const BLOG = 'http://blog.remind.com';
const MARKETING = Config.Environment.R101_MARKETING_URL;
const ZENDESK = 'https://help.remind.com/hc/en-us';

export default {
  MARKETING,
  SIGN_UP: `${MARKETING}/?sign-up=true`,
  ABOUT: `${MARKETING}/about`,
  CAREERS: `${MARKETING}/careers`,
  COMMUNITY: `${MARKETING}/community`,
  COMMUNITY_GUIDELINES: `${MARKETING}/community-guidelines`,
  FEATURES: `${MARKETING}/features`,
  HOW_IT_WORKS_TEACHERS: `${MARKETING}/how-it-works/teachers`,
  PRESS: `${MARKETING}/press`,
  PRIVACY_POLICY: `${MARKETING}/privacy-policy`,
  RCE: `${MARKETING}/connected-educator/thank-you`,
  RESOURCES: `${MARKETING}/resources`,
  SCHOOLS: `${MARKETING}/schools`,
  TEACH_SMALL: `${MARKETING}/teach-small`,
  TEACHER_RESOURCES: `${MARKETING}/resources/teachers`,
  TERMS_OF_SERVICE: `${MARKETING}/terms-of-service`,
  JOIN: `${MARKETING}/join`,

  APP_DOWNLOAD: 'http://rmd.me/a',
  HELP: 'https://help.remind.com',

  CONTACT_EMAIL: 'contact@remindhq.com',
  REPORT_EMAIL: 'report@remindhq.com',
  SCHOOLS_EMAIL: 'schooladmin@remindhq.com',
  SUPPORT_EMAIL: 'support@remindhq.com',

  FACEBOOK: 'https://facebook.com/remindhq',
  TWITTER: 'https://twitter.com/remindhq',
  INSTAGRAM: 'https://instagram.com/remindhq',
  PINTEREST: 'https://pinterest.com/remindhq',
  YOUTUBE: 'https://youtube.com/remindhq',
  YOUTUBE_TUTORIAL_VIDEOS: 'https://www.youtube.com/user/remind101/videos',
  LINKEDIN: 'https://www.linkedin.com/company/remind101',
  GOOGLE_PLUS: 'https://plus.google.com/+remindhq',
  RSS: `${BLOG}/feed`,

  APP_STORE: 'https://itunes.apple.com/us/app/remind101/id522826277',
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.remind101&referrer=utm_source%3Dremind101%26utm_medium%3D%252Fapps%26utm_campaign%3Dget-it-on-google-play',
  GOOGLE_PLAY_AUTOLOGIN_PARAM: '%26utm_term%3Dautologin_',
  GOOGLE_PLAY_SHORT_LINK_REFERRER_AUTOLOGIN_PARAM: '?referrer=utm_term%3Dautologin_',
  MAC_APP_STORE: 'https://itunes.apple.com/us/app/remind-safe-classroom-communication/id1059891751',
  QR: 'https://qr.remind.com',

  BLOG,

  ZENDESK,
  CHAT_FAQ: `${ZENDESK}/sections/200876739-Chat`,
  CHAT_RESTRICTIONS: `${ZENDESK}/articles/204484215-Are-there-restrictions-on-who-can-chat`,
  CSV_FAQ: `${ZENDESK}/articles/208218366`,
  FORGOT_PASSWORD: `${ZENDESK}/articles/202132223-I-did-not-receive-a-password-reset-link-via-email`,
  MOG_FAQ: `${ZENDESK}/articles/203179827`,
  NO_DEVICES: `${ZENDESK}/articles/202540978-How-do-I-change-how-I-receive-messages-email-text-push-notifications-`,
  PARENTAL_CONSENT: `${ZENDESK}/articles/205762439`,
  SUPPORTED_BROWSERS: `${ZENDESK}/articles/202409729-Which-browsers-does-Remind-support-`,
  SELECTING_SCHOOL: `${ZENDESK}/articles/204922059-What-does-selecting-a-school-mean-`,
  USING_ACTIVITIES: `${ZENDESK}/categories/201278283-Using-Activities`,

  CONTACT_FORM: `${ZENDESK}/requests/new?ticket_form_id=75133`,

  DOWNLOAD_CHROME: 'https://www.google.com/chrome/browser/desktop/',
  DOWNLOAD_FIREFOX: 'https://www.getfirefox.com/',
};



// WEBPACK FOOTER //
// ./src/constants/LinkConstants.js